import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import rootReducer from "./reducers";
import { initialize, addTranslationForLanguage } from "react-localize-redux";

let middlewares = [thunkMiddleware];
if (process.env.NODE_ENV === "development") {
  const loggerMiddleware = createLogger({
    collapsed: true,
  });
  middlewares.push(loggerMiddleware);
}

// Expose redux store to the dev tools in development mode
const composeEnhancer = (process.env.NODE_ENV === "development" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

const store = createStore(
    rootReducer,
    composeEnhancer(applyMiddleware(...middlewares))
);

const languages = [
  { name: "English (UK)", code: "en-GB" },
  { name: "Finnish", code: "fi" },
  { name: "Norwegian", code: "no" },
  { name: "Swedish", code: "sv" },
];
store.dispatch(initialize(languages));
const json = require("../translations/strings.en-GB.json");
store.dispatch(addTranslationForLanguage(json, "en-GB"));

const jsonFi = require("../translations/strings.fi.json");
store.dispatch(addTranslationForLanguage(jsonFi, "fi"));

const jsonNo = require("../translations/strings.no.json");
store.dispatch(addTranslationForLanguage(jsonNo, "no"));

const jsonSv = require("../translations/strings.sv.json");
store.dispatch(addTranslationForLanguage(jsonSv, "sv"));

export { store };
